import { render, staticRenderFns } from "./ShopifySync.vue?vue&type=template&id=a380f7ba&scoped=true"
import script from "./ShopifySync.vue?vue&type=script&lang=js"
export * from "./ShopifySync.vue?vue&type=script&lang=js"
import style0 from "./ShopifySync.vue?vue&type=style&index=0&id=a380f7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a380f7ba",
  null
  
)

export default component.exports